import React from 'react';
import classNames from 'classnames';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import UploadIcon from 'icons/Upload.icon';
import {
  AGREEMENT_FILE_LIMIT_PARAMS,
  AGREEMENT_PDF_DROPZONE_OPTIONS,
  getDroppedFile,
} from '../../utils';

import './AgreementPdfDropzone.styles.scss';

type AgreementPdfDropzoneProps = {
  className?: string;
  isDisabled?: boolean;
  onFileSelect: (file: File) => void;
};

const AgreementPdfDropzone: React.FC<AgreementPdfDropzoneProps> = (props) => {
  const { className, isDisabled, onFileSelect } = props;

  const { t } = useTranslation();

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    ...AGREEMENT_PDF_DROPZONE_OPTIONS,
    disabled: isDisabled,
    onDrop: (accepted, rejections) => {
      const file = getDroppedFile(accepted, rejections);

      if (file) onFileSelect(file);
    },
  });

  const classes = classNames(
    'agreement-pdf-dropzone',
    { 'agreement-pdf-dropzone--drag-active': isDragActive },
    className,
  );

  return (
    <div {...getRootProps({ className: classes })}>
      <input {...getInputProps()} />

      <UploadIcon className="agreement-pdf-dropzone__icon" />
      <p className="agreement-pdf-dropzone__title">{t('agreementUploadPdf')}</p>
      <p className="agreement-pdf-dropzone__note">{t('orDragAndDrop')}</p>
      <p className="agreement-pdf-dropzone__note">
        {t('agreementPdfLimits', AGREEMENT_FILE_LIMIT_PARAMS)}
      </p>
    </div>
  );
};

export default AgreementPdfDropzone;
